import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customCurrency' })
export class CustomCurrency implements PipeTransform {
    transform(value: string): string {
        return (value === 'bs' ? 'Bs' : '$');
    }
}
